import React, { useEffect, useState } from 'react';
import { CheckBox } from '.';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const tajoOptions = [
    { label: 'CERRO VERDE', value: 'CERRO VERDE' },
    { label: 'CANTERA APO', value: 'CANT APO' },
    { label: 'CERRO NEGRO', value: 'CERRO NEGRO' },
    { label: 'SANTA ROSA', value: 'SANTA ROSA' },
    { label: 'ENLOZADA', value: 'ENLO ZADA' },
    { label: 'LINGA', value: 'LINGA ' },
    { label: 'SADDLE DAM 1', value: 'SDAM I ' },
    { label: 'SADDLE DAM 2', value: 'SDAM II ' },
    { label: 'SADDLE DAM 4', value: 'SDAM IV ' },
    { label: 'SADDLE DAM 5', value: 'SDAM V ' },
    { label: 'QSD1', value: 'QSD I ' },
    { label: 'QSD2', value: 'QSD II ' },
    { label: 'QSD4', value: 'QSD IV ' },
];

export default function CheckSelectInput({
    nameItem,
    label,
    valueItem,
    checked,
    onInputChange,
    handleButtonClick
}) {

    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleCheckChange = (event) => {

        const checked = event.target.checked;

        setIsChecked(checked);

        if (checked) {

            const selectedOption = tajoOptions.find(
                option => option.value === valueItem
            );

            onInputChange({
                [nameItem]: selectedOption?.value || ''
            });

        } else {

            onInputChange({
                [nameItem]: ''
            });

            handleButtonClick(0);
        }
    };

    return (
        <div className="grid grid-cols-2">

            <span className="place-self-center justify-self-start font-Poppins text-sm font-thin">

                <CheckBox
                    className={`text-[#4D4D4D] tracking-widest ${
                        label === "PRIMARIO" || label === "PRECORTE"
                            ? "pr-7"
                            : ""
                    }`}
                    checked={isChecked}
                    onChange={handleCheckChange}
                    name="checkInput"
                >
                    {label}
                </CheckBox>

            </span>

            <Autocomplete
                id={nameItem}

                disabled={!isChecked}

                options={tajoOptions}

                value={
                    isChecked
                        ? tajoOptions.find(
                            option => option.value === valueItem
                        ) || null
                        : null
                }

                onChange={(event, newValue) => {

                    if (newValue) {

                        onInputChange({
                            [nameItem]: newValue.value
                        });

                    } else {

                        onInputChange({
                            [nameItem]: ''
                        });

                        handleButtonClick(0);
                    }
                }}

                getOptionLabel={(option) => option.label}

                isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                }

                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Seleccionar Tajo"
                        inputProps={{
                            ...params.inputProps,
                            readOnly: true
                        }}
                    />
                )}
            />

        </div>
    );
}